import qs from 'qs';
import api, { apiSuccessOutput } from '@/shared/config/api.js';

// ----------------- Channel  -----------------
// Get Channel List Pagination
export const getChannelList = async (
  name,
  isActive,
  channelTypeId,
  page = 1,
  size = 10,
) => {
  return apiSuccessOutput(
    await api.get('/rule/v1/channel/paginate', {
      params: {
        name,
        is_active: isActive,
        channel_type_id: channelTypeId,
        page,
        size,
      },
      showToast: false,
    }),
  );
};

// Get Channel By Id Detail
export const getChannelById = async (channelId) => {
  return apiSuccessOutput(
    await api.get(`/rule/v1/channel/${channelId}`, {
      showToast: false,
    }),
  );
};

// Get Channel Type List
export const getChannelTypeList = async () => {
  return apiSuccessOutput(
    await api.get('/rule/v1/channel-type', {
      showToast: false,
    }),
  );
};

// Get Channel Type Fields
export const getChannelTypeFieldsList = async (channelTypeId) => {
  return apiSuccessOutput(
    await api.get(`/rule/v1/channel-type-field/${channelTypeId}`, {
      showToast: false,
    }),
  );
};

// Create Channel
export const createChannel = async (
  name,
  channel_type_id,
  extra_config = {},
) => {
  return apiSuccessOutput(
    await api.post('/rule/v1/channel', {
      name,
      channel_type_id,
      extra_config,
    }),
  );
};

// Update Channel
export const updateChannel = async (
  channelId,
  name,
  channel_type_id,
  is_active,
  extra_config = {},
) => {
  return apiSuccessOutput(
    await api.put(`/rule/v1/channel/${channelId}`, {
      name,
      channel_type_id,
      is_active,
      extra_config,
    }),
  );
};

// Delele Channel
export const deleteChannel = async (channelId) => {
  return apiSuccessOutput(await api.delete(`/rule/v1/channel/${channelId}`));
};

// ----------------- Rules  -----------------
// Get Rules List Pagination
export const getRulesList = async (
  name,
  targetType,
  severity,
  isActive,
  page = 1,
  size = 10,
) => {
  return apiSuccessOutput(
    await api.get('/rule/v1', {
      params: {
        name,
        target_type: targetType,
        severity,
        is_active: isActive,
        page,
        size,
      },
      showToast: false,
    }),
  );
};

// Get Rules By Id
export const getRulesById = async (ruleId) => {
  return apiSuccessOutput(
    await api.get(`/rule/v1/${ruleId}`, {
      showToast: false,
    }),
  );
};

// Create Rules
export const createRules = async (
  name,
  target_type,
  rule_type,
  target_eui,
  target_tag_id,
  severity,
  condition_expression,
  channel_id,
) => {
  return apiSuccessOutput(
    await api.post('/rule/v1', {
      name,
      target_type,
      rule_type,
      target_eui,
      target_tag_id,
      severity,
      condition_expression,
      channel_id,
    }),
  );
};

// Update Rules
export const updateRules = async (
  ruleId,
  name,
  rule_type,
  severity,
  condition_expression,
  is_active,
) => {
  return apiSuccessOutput(
    await api.put(`/rule/v1/${ruleId}`, {
      name,
      rule_type,
      severity,
      condition_expression,
      is_active,
    }),
  );
};

// Delete Rules
export const deleteRules = async (ruleId) => {
  return apiSuccessOutput(await api.delete(`/rule/v1/${ruleId}`));
};

// Assign Channel to Rules
export const assignChannelRules = async (ruleId, channel_id) => {
  return apiSuccessOutput(
    await api.post(`/rule/v1/channels/${ruleId}`, {
      channel_id,
    }),
  );
};

// Update Rule Channel
export const updateAssignRules = async (ruleChannelId, is_active) => {
  return apiSuccessOutput(
    await api.put(`/rule/v1/channels/${ruleChannelId}`, {
      is_active,
    }),
  );
};

// Delete Rule Channel
export const deleteAssingRules = async (ruleChannelId) => {
  return apiSuccessOutput(
    await api.delete(`/rule/v1/channels/${ruleChannelId}`),
  );
};

// ----------------- Alert  -----------------
// Get Alert List Pagination
export const getAlertList = async (
  status,
  page = 1,
  size = 10,
  targetEui = null,
  startTime = null,
  endTime = null,
) => {
  const params = { page, size };

  if (status && status.length > 0) {
    params.status = Array.isArray(status) ? status : [status];
  }

  if (targetEui) {
    params.target_eui = targetEui;
  }
  if (startTime) params.start_time = startTime;
  if (endTime) params.end_time = endTime;

  return apiSuccessOutput(
    await api.get('/rule/v1/alert/paginate', {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, {
          arrayFormat: 'repeat',
        }),
      showToast: false,
    }),
  );
};

// Update Alert
export const updateAlert = async (alertId, status) => {
  return apiSuccessOutput(
    await api.put(`/rule/v1/alert/${alertId}`, {
      status,
    }),
  );
};

// Delete Alerts
export const deleteAlert = async (alertId) => {
  return apiSuccessOutput(await api.delete(`/rule/v1/alert/${alertId}`));
};
